import { useState } from 'react'
import InputController from '../../../../../Global/InputController'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import { arrayTypeFilesForm } from '../../../../../../const/arrayTypeFilesForm'
import DragDropComponent from '../../../../../../helpers/DragDropComponent'

const extensions_allowed_image = ['.png', '.jpg', '.jpeg']
const extensions_allowed_all = ['.png', '.jpg', '.jpeg', '.pdf', '.csv']
const sizeMaxFile = 8 // EXPRESADO EN MB.

export const PreviewFormField = ({
  control,
  fieldsData,
  onChangeFile = () => {},
  onChangeFileImg = () => {},
  maxFiles,
  newDropAttachment = false,
}) => {
  const [files, setFiles] = useState(1)

  const handleMsjFile = async ({ msg, name }) => {
    setFiles({ ...files, [name]: null })

    return toastSweetAlert({
      mode: 'error',
      message: msg,
    })
  }

  const handleOneFile = async ({ e, name, optionsFile }) => {
    if (!e.target.files[0]) {
      return
    }
    if (
      e.target.files[0].type === 'image/jpeg' ||
      e.target.files[0].type === 'image/png' ||
      e.target.files[0].type === 'image/jpg'
    )
      return

    const fileName = e.target.files[0].name.toLowerCase()
    const lastDot = fileName.lastIndexOf('.')
    const extension = fileName.slice(lastDot, fileName.length)

    const type = e.target.files[0].type

    switch (optionsFile.type) {
      case 'application/pdf':
        if (type !== 'application/pdf')
          return await handleMsjFile({
            msg: optionsFile.validateFormatMsg,
            name,
          })
        break
      case 'text/csv':
        if (type !== 'text/csv')
          return await handleMsjFile({
            msg: optionsFile.validateFormatMsg,
            name,
          })
        break
      case 'image/jpeg':
        if (type !== 'image/jpeg')
          return await handleMsjFile({
            msg: optionsFile.validateFormatMsg,
            name,
          })
        break
      case 'image/png':
        if (type !== 'image/png')
          return await handleMsjFile({
            msg: optionsFile.validateFormatMsg,
            name,
          })
        break
      case 'image/*':
        if (extensions_allowed_image.indexOf(extension) === -1) {
          return await handleMsjFile({
            msg: optionsFile.validateFormatMsg,
            name,
          })
        }
        break
      case '*':
        if (extensions_allowed_all.indexOf(extension) === -1) {
          return await handleMsjFile({
            msg: optionsFile.validateFormatMsg,
            name,
          })
        }
        break
      default:
        return toastSweetAlert({
          mode: 'error',
          message: 'No existe tipo',
        })
    }

    if (e.target.files[0].size / 1048576 > sizeMaxFile) {
      return await handleMsjFile({
        msg: `El archivo no puede superar los ${sizeMaxFile}MB`,
        name,
      })
    }

    setFiles({ ...files, [name]: e.target.files[0] })
  }

  return (
    <>
      {fieldsData?.length > 0 &&
        fieldsData.map((field) => {
          const type = field.TypeOfField.name
          let input = null

          if (type === 'text') {
            input = (
              <InputController
                label={field?.label}
                name={field.name}
                inputType={'text'}
                placeholderTxt={field?.placeholder}
                control={control}
              />
            )
          } else if (type === 'textarea') {
            input = (
              <InputController
                label={field?.label}
                name={field.name}
                inputType={'textarea'}
                placeholderTxt={field?.placeholder}
                control={control}
              />
            )
          } else if (type === 'choosen_db') {
            input = (
              <InputController
                label={field?.label}
                name={field.name}
                inputType={'choosen'}
                placeholderTxt={field?.placeholder}
                options={field?.choosenSourceData}
                control={control}
              />
            )
          } else if (type === 'choosen_json') {
            const opts = JSON.parse(field.TypeChoosenSourceOfField?.source_json)
            input = (
              <InputController
                label={field?.label}
                name={field.name}
                inputType={'choosen'}
                placeholderTxt={field?.placeholder}
                options={opts ?? []}
                control={control}
              />
            )
          } else if (type === 'number') {
            input = (
              <InputController
                label={field?.label}
                name={field.name}
                inputType="number"
                placeholderTxt={field?.placeholder}
                control={control}
              />
            )
          } else if (type === 'file') {
            const foundTypeFile = arrayTypeFilesForm.find(
              (item) => item.value === field.file_types_allowed
            )

            input = (
              <InputController
                label={field?.label}
                name={field.name}
                inputType="file"
                formatAccept={foundTypeFile.formatAccept}
                validateFormat={foundTypeFile.validateFormat}
                validateFormatMsg={foundTypeFile.validateFormatMsg}
                control={control}
                changeAction={(e) => {
                  handleOneFile({
                    e,
                    name: field.name,
                    optionsFile: foundTypeFile,
                  })
                  onChangeFile(e, false)
                }}
              />
            )
          } else if (type === 'image') {
            input = (
              <InputController
                label={field?.label}
                name={field.name}
                inputType="attachment"
                allowedFileTypes={['png', 'jpg', 'jpeg']}
                control={control}
                maxFiles={maxFiles}
                changeAction={(e) => onChangeFileImg(e, true)}
                newDropAttachment={newDropAttachment}
              />
            )
            // input = (
            //   <InputController
            //     label={field?.label}
            //     name={field.name}
            //     inputType="image"
            //     validateFormat={'imageavatar'}
            //     validateFormatMsg={'Solo se admite JPG, JPGE y PNG'}
            //     control={control}
            //     changeAction={(e) => onChangeFileImg(e, false)}
            //   />
            // )
          }
          // else if (type === 'attachment') {
          //   input = (
          //     <InputController
          //       label={field?.label}
          //       name={field.name}
          //       inputType="attachment"
          //       validateFormat={'imageavatar'}
          //       validateFormatMsg={'Solo se admite JPG, JPGE y PNG'}
          //       control={control}
          //       maxFiles={maxFiles}
          //       // changeAction={(e) => onChangeFileImg(e, true)}
          //     />
          //   )
          // }

          return (
            <div
              key={field.id}
              className={`mb-3 col-12 col-sm-${field?.col_width ?? 12}`}
            >
              {input}
            </div>
          )
        })}
    </>
  )
}

export default PreviewFormField
